// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiSeizeSettings {
    'rememes_submission_tdh_threshold': number;
    'all_drops_notifications_subscribers_limit': number;
    'memes_wave_id': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "rememes_submission_tdh_threshold",
            "baseName": "rememes_submission_tdh_threshold",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "all_drops_notifications_subscribers_limit",
            "baseName": "all_drops_notifications_subscribers_limit",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_wave_id",
            "baseName": "memes_wave_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiSeizeSettings.attributeTypeMap;
    }

    public constructor() {
    }
}
